import { Controller } from 'react-hook-form';

import { IAllowedMembersSection, IPAD_CONFIG_FORM_FIELDS } from '@/features/ipad-configs';
import { FaceIdProfileService } from '@/services';
import { mapFaceIdProfileResponseToMultiSelectOptions } from '@/utils';
import MultiSelect from '@/components/common/MultiSelect/MultiSelect';

const AllowedMembersSection = ({ control, errors }: IAllowedMembersSection) => {
  return (
    <div className="flex flex-col gap-6">
      <h5 className="font-bold text-h5 text-brand-primary-darkest">Allowed Members</h5>
      <Controller
        name={IPAD_CONFIG_FORM_FIELDS.allowMembers}
        control={control}
        render={({ field }) => (
          <MultiSelect
            label="Face Profile ID"
            placeholder="Select Face Profile ID"
            onValueChange={field.onChange}
            maxCount={-1}
            hideSelectAll
            searchCallback={async (searchValue) =>
              mapFaceIdProfileResponseToMultiSelectOptions(
                await FaceIdProfileService.GetFaceIdProfiles(searchValue),
              )
            }
            required
            error={errors[IPAD_CONFIG_FORM_FIELDS.allowMembers]?.message}
            isLabelstyled
          />
        )}
      />
      <div className="w-full h-px bg-neutral-n3"></div>
    </div>
  );
};

export default AllowedMembersSection;
